import * as React from "react";
const SvgBarChart = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m2.17 1.871.002 8.58.002 8.58.752.004.752.002V3.38h4.117V19.037h1.508V13.69h4.588v5.348H15.398V8.064h4.588V19.037h1.498V6.557h-7.593v5.625H9.303V1.87H5.736Zm9.6 18.752c-5.284-.001-9.61 0-9.614.004a23.68 23.68 0 0 0-.006.754v.748H21.38l-.002-.752-.002-.752Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgBarChart;
